let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4mLGd")).then(() => parcelRequire('75US5'));